import { builder } from '../../../../../../common/js/configs';
import { units } from '../../../../../../common/js/configs/constants';

export const commonInArticleConfig = {
  creative: builder.holder({
    creativeRatio: builder.number('creative_ratio', {
      l:'',
      description: `Select the correct ratio following your creative sizes:<br>
0.95: 950x1000px<br>
0.60: 520x867px<br>
0.67: 320x480px<br>
0.5: 300x600px`,
      unit: units.aspectRatio
    })
  })
};
